// @flow

// Libs
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

// Operator
import assetMigrateOperator from 'hfty-operator-asset-migrate'

// Selectors
import { default as assetMigrateOperation$ } from '../selectors/operation'
import { default as farms$ } from '../selectors/farms'
import { default as fields$ } from '../selectors/fields'
import { seasons$ } from 'fc-seasons'
import { jobs$ } from 'hfty-soil-jobs'

// Actions
import { submitMigrateAsset } from '../actions'

// Components
import Layout from '../component/Layout'


function mapStateToProps (state: Object): Props {
  return {
    farms: farms$(state),
    jobs: jobs$(state),
    fields: fields$(state),
    seasons: seasons$(state),
    operation: assetMigrateOperation$(state),
  }
}

type MapDispatchToProps = {
  actions: {
    onSubmit: Function,
    onCancelOperations: Function,
    onSubmitOperations: Function,
  }
}

function mapDispatchToProps (dispatch: Dispatch<*>): MapDispatchToProps {
  return {
    actions: bindActionCreators({
      onSubmit: submitMigrateAsset,
      onChangeOperation: assetMigrateOperator.actionCreators.updateOperation,
      onCancelOperations: assetMigrateOperator.actionCreators.cancelOperations,
    }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Layout)
